(() => {
  if (customElements.get('product-form')) {
    return;
  }

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.form.querySelector('[name="add"]');
      this.cartDrawer = document.querySelector('#rebuy-cart');
      this.productBar = document.querySelector(
        `#ProductBar-${this.dataset.sectionId}`
      );

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const parentElement = event.target.closest('[data-main-product]');
      const purchaseOptions = document.querySelector(
        'purchase-options'
      );
      if (
        !!purchaseOptions &&
        !purchaseOptions.isOneTimePurchase() &&
        !this.hasAttribute('data-has-selling-plan')
      ) {
        purchaseOptions.showError();
        return;
      }

      this.submitButton.classList.add('disabled');

      const formData = new FormData(this.form);

      const mainVariantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || '1', 10);

      // Collect main product properties from form inputs like properties[Gift Note]
      const mainProperties = {};
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('properties[')) {
          const propName = key.replace('properties[', '').replace(']', '');
          mainProperties[propName] = value;
        }
      }

      if (this.hasAttribute('data-has-pre-order')) {
        formData.append('properties[Pre-order]', '✓');
      }

      // Selling plan support if present
      const sellingPlan = formData.get('selling_plan');

      const items = [
        {
          id: mainVariantId,
          quantity,
          properties: mainProperties
        }
      ];

      if (sellingPlan) {
        items[0].selling_plan = sellingPlan;
      }

      // Upsell checkbox
      const upsellCheckbox = parentElement?.querySelector('[data-addon-spa-service]');

      if (upsellCheckbox?.checked) {
        const upsellVariantId = upsellCheckbox.dataset.upsellVariantId;
        const amount = upsellCheckbox.dataset.addonSpaAmount;
        const title = upsellCheckbox.dataset.pdpTitle;
        const handle = upsellCheckbox.dataset.pdpHandle;

        if (upsellVariantId) {
          items.push({
            id: upsellVariantId,
            quantity: 1,
            properties: {
              '_price': amount,
              '_title': title,
              '_handle': handle,
              '_created': Math.floor(Date.now() / 1000)
            }
          });
        }
      }

      const payload = {
        items,
        sections: this.cartDrawer
          ?.getSectionsToRender()
          ?.map(section => section.section),
        sections_url: window.location.pathname
      };
      console.log("payload", payload)

      fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (response.errors) {
            const errorMsg = typeof response.errors === 'string'
              ? response.errors
              : Object.values(response.errors).flat().join(', ');
            this.handleErrorMessage(errorMsg);
            return;
          }

          this.handleErrorMessage(false);
          if (this.cartDrawer) {
            this.cartDrawer.renderContents(response);
          }
        })
        .catch(error => {
          console.error(error);
          this.handleErrorMessage('Something went wrong. Please try again.');
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;

      let message = errorMessage;

      if (typeof errorMessage === 'object' && errorMessage !== null) {
        message = Object.values(errorMessage).flat().join(', ');
      }

      errorWrapper.classList.toggle('hidden', !message);
      errorWrapper.textContent = message || '';
    }


    toggleAddButton(disable, text) {
      [
        this.submitButton,
        this.productBar?.querySelector('[name="add"]')
      ].forEach(submitButton => {
        if (disable) {
          submitButton?.setAttribute('disabled', 'disabled');
          if (text && submitButton) submitButton.textContent = text;
        } else if (submitButton) {
          submitButton.removeAttribute('disabled');
          submitButton.textContent = this.hasAttribute(
            'data-has-selling-plan'
          )
            ? window.theme.strings.addSubscriptionToCart
            : (submitButton.textContent = this.hasAttribute(
                'data-has-pre-order'
              )
                ? window.theme.strings.preOrder
                : window.theme.strings.addToCart);
        }
      });
    }
  }

  customElements.define('product-form', ProductForm);
})();
